<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-center align-items-center">
      <div class="copyright p-0 m-0">
        Developed by
        <a href="https://www.vero-as.com/" target="_blank" rel="noopener"
          >VERO</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.footer{
  height: fit-content;
}
.copyright{
  height: fit-content;
}
</style>
